import { IconBrandDribbble, IconBrandFacebook, IconBrandGmail, IconBrandGoogle, IconBrandInstagram, IconBrandTelegram, IconBrandWhatsapp, IconBrandYoutube, IconBrandZoom, IconMail, IconQuestionMark } from "@tabler/icons-react";

export const renderIcon = (text) => {
   switch (text.toLowerCase()) {
      case 'instagram':
         return <IconBrandInstagram color="var(--color-text-primary)" stroke={1.5} />
      case 'facebook':
         return <IconBrandFacebook color="var(--color-text-primary)" stroke={1.5} />
      case 'mail':
         return <IconMail color="var(--color-text-primary)" stroke={1.5} />
      case 'email':
         return <IconMail color="var(--color-text-primary)" stroke={1.5} />
      case 'whatsapp':
         return <IconBrandWhatsapp color="var(--color-text-primary)" stroke={1.5} />
      case 'youtube':
         return <IconBrandYoutube color="var(--color-text-primary)" stroke={1.5} />
      case 'dribble':
         return <IconBrandDribbble color="var(--color-text-primary)" stroke={1.5} />
      case 'gmail':
         return <IconBrandGmail color="var(--color-text-primary)" stroke={1.5} />
      case 'google':
         return <IconBrandGoogle color="var(--color-text-primary)" stroke={1.5} />
      case 'telegram':
         return <IconBrandTelegram color="var(--color-text-primary)" stroke={1.5} />
      case 'zoom':
         return <IconBrandZoom color="var(--color-text-primary)" stroke={1.5} />
      case 'question':
         return <IconQuestionMark color="var(--color-text-primary)" stroke={1.5} />
      default:
         return null;
   }
}

